module.exports = __webpack_public_path__ + "static/media/actify_icon.f768a47a.svg";